import { ReactNode } from "react";
import "./AdminSection.css";

type AdminSectionProps = {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

export default function AdminSection({
  title,
  action,
  children,
  className,
}: AdminSectionProps) {
  const classes = ["admin-section", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      {(title || action) && (
        <div className="admin-section-header">
          {title ? <h3>{title}</h3> : <span />}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
